
  import * as ipxRuntime$kZ6Gv5CRhl4Cf8Q_45T8C1tSB7B7F3lXymgr8qgqfH__E from '/tmp/workspace/staging/ghl-membership-frontend-clientportal/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$kZ6Gv5CRhl4Cf8Q_45T8C1tSB7B7F3lXymgr8qgqfH__E, defaults: {} }
    }
  }
